module.exports = __webpack_public_path__ + "60c932299a5a6afe0ca7f5c5cef635d2.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/choose-folder/choose-shared-folder.html
// module id = 1834
// module chunks = 0